
import { Component, mixins, Ref } from 'nuxt-property-decorator';
import { RawHtml, Lightbox } from 'fourwaves-shared/components';
import { ContentBlockImageData, GalleryBlockModel, LightboxImage } from 'fourwaves-shared';
import ContentBlockMixin from '../../ContentBlockMixin';
import ContentBlockImage from '../ContentBlockImage.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
    Lightbox,
  },
})
export default class GalleryBlockGrid extends mixins(ContentBlockMixin<GalleryBlockModel>) {
  @Ref() readonly lightbox?: Lightbox;

  get rootStyles(): Record<string, number | string> {
    return { '--max-row': this.settings.maxItemsInRow };
  }

  get lightboxImages(): LightboxImage[] {
    return this.newData.items
      .filter(({ originalUrl }) => Boolean(originalUrl[this.$i18n.locale]))
      .map(image => {
        const url = new URL(image.originalUrl[this.$i18n.locale]);
        url.searchParams.set('auto', 'format');

        return {
          id: image.fileUploadId[this.$i18n.locale],
          src: url.toString(),
          alt: image.altText[this.$i18n.locale],
        };
      });
  }

  get imageWidth(): number {
    return 3576 / this.settings.maxItemsInRow;
  }

  public getItemTagName(image: ContentBlockImageData): string {
    return image.originalUrl && image.originalUrl[this.$i18n.locale] ? 'button' : 'div';
  }

  public imageClickHandler({ currentTarget }: MouseEvent, image: ContentBlockImageData): void {
    if (!(currentTarget instanceof HTMLButtonElement)) return;

    if (!image.originalUrl[this.$i18n.locale]) return;

    const imageIndex = this.newData.items.findIndex(item => item === image);
    if (imageIndex === -1) return;

    this.lightbox?.open(currentTarget, imageIndex);
  }
}
